import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';

import {
  EditableImage,
  injectIntl,
} from 'components';
import AddPhotoIcon from '@material-ui/icons/AddAPhoto';
import IconButton from '@material-ui/core/IconButton';
import { grey700 } from '@material-ui/core/colors';

import { dispatchMaker } from 'helpers/utils';
import { uploadLicenseImage, updateProfile } from 'redux/auth/actions';

const LicenseImage = ({
  image,
  formatMessage,
  updateProfile,
  uploadLicenseImage,
}) => {
  const onUpload = ({
    filetype,
    imageBase64,
    onRequestClose,
  }) => {
    uploadLicenseImage({
      base64: imageBase64,
      filetype,
      onSuccess: onRequestClose,
    });
  };

  const onRemove = ({ onRequestClose }) => {
    updateProfile({ licenseUrl: '', onSuccess: onRequestClose });
  };

  const renderer = ({
    onClick,
    uploadImageDialog,
  }) => (
    <div className="license-image-upload">
      {formatMessage('License or Certificate Image')}
      <div className="action-buttons">
        {image ? (
          <img alt="" className="preview license-image" src={image} onClick={onClick} />
        ) : (
          <div title={formatMessage('Add Picture')}>
            <IconButton
              disabled={false}
              onClick={onClick}
              style={{
                height: 40,
                padding: 5,
                width: 40,
              }}
            >
              <AddPhotoIcon color={grey700} />
            </IconButton>
          </div>
        )}
      </div>
      {uploadImageDialog}
    </div>
  );

  renderer.propTypes = {
    onClick: PropTypes.func.isRequired,
    uploadImageDialog: PropTypes.node.isRequired,
  };

  return (
    <EditableImage
      image={image}
      onUpload={onUpload}
      onRemove={onRemove}
      renderer={renderer}
    />
  );
};

LicenseImage.propTypes = {
  image: PropTypes.string,
  formatMessage: PropTypes.func.isRequired,
  updateProfile: PropTypes.func.isRequired,
  uploadLicenseImage: PropTypes.func.isRequired,
};

LicenseImage.defaultProps = {
  image: '',
};

export default compose(
  setDisplayName('LicenseImage'),
  connect(
    () => ({}),
    dispatch => ({
      ...dispatchMaker([
        [uploadLicenseImage, 'uploadLicenseImage'],
        [updateProfile, 'updateProfile'],
      ])(dispatch),
    }),
  ),
  injectIntl,
)(LicenseImage);
